// extracted by mini-css-extract-plugin
export var dash = "svgBackground-module--dash--7be15";
export var holder = "svgBackground-module--holder--d7a49";